import { Delete } from '@mui/icons-material';
import { CardContent, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { bytesToKiloBytesSize, bytesToMegaBytesSize } from 'components/forms/utils';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useImageUploadStyles from './styles';
import { ImageCardContentProps } from './types';
import { isBase64 } from './util';

const ImageCardContent: React.FunctionComponent<ImageCardContentProps> = (props) => {
  const { file, dateFormat, onDelete } = props;
  const classes = useImageUploadStyles();
  const { t } = useTranslation('common');
  const isBase64Image = isBase64(file!);
  const fileSize =
    file!.size! > 10_000
      ? `${bytesToMegaBytesSize(Number(file!.size))} ${t('mb')}`
      : `${bytesToKiloBytesSize(Number(file!.size))} ${t('kb')}`;
  const timestamp = moment(file?.timestamp).format(dateFormat);
  const title = isBase64Image ? t('unknown') : file!.additionalData?.title || file?.name;

  const renderImageDetail = () => {
    return (
      <>
        <CardContent className={classes.imageContentWrapper}>
          <Grid container spacing={2}>
            <Grid xs={11} md={10}>
              <Tooltip title={title}>
                <Typography
                  gutterBottom
                  variant='h6'
                  component='div'
                  className={classes.fileName}
                  noWrap
                >
                  {title}
                </Typography>
              </Tooltip>
            </Grid>
            {onDelete && (
              <Grid xs={1} md={2} className={classes.deleteBtn}>
                <IconButton
                  aria-label='delete'
                  className={classes.deleteIcon}
                  onClick={(event) => onDelete(file!, event)}
                >
                  <Delete fontSize='small' />
                </IconButton>
              </Grid>
            )}

            {!isBase64Image && (
              <>
                <Grid xs={10} md={8}>
                  <Typography
                    variant='body2'
                    color='text.secondary'
                    sx={{ fontSize: 12 }}
                    className={classes.contentLeftLayout}
                  >
                    {timestamp}
                  </Typography>
                </Grid>
                <Grid xs={2} md={4}>
                  <Typography
                    variant='body2'
                    color='text.secondary'
                    sx={{ fontSize: 12 }}
                    className={classes.contentRightLayout}
                  >
                    {fileSize}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
      </>
    );
  };
  return renderImageDetail();
};

export default ImageCardContent;
